/** 'global' es el sentinel que usa el builder (`deriveOuIds` en index.tsx / useCreateSurvey.ts)
 *  cuando no se seleccionó ninguna OU — no es un id real, nunca se debe pasar al resolver. */
const GLOBAL_SENTINEL = 'global';

export function formatOuAudience(
  ouIds: string[] | undefined,
  resolveOuName: (ouId: string) => string,
  globalLabel: string,
): string {
  if (!ouIds || ouIds.length === 0) return '—';
  if (ouIds.includes(GLOBAL_SENTINEL)) return globalLabel;
  return ouIds.map(resolveOuName).join(', ');
}
